import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

// Define your RecentActivity type
import { RecentActivity } from '../types';

// API function to fetch recent activities
export const getRecentActivities = async (): Promise<RecentActivity[]> => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(timezone, "timezone");

  const response = await axios.get(`/api/v1/user/recentactivity`, {
    headers: {
      'TimeZone': timezone,
    },
  });
console.log(response, "response");

  return response.data;
};

// Hook to use recent activities in components
type UseRecentActivitiesOptions = {
  config?: QueryConfig<typeof getRecentActivities>;
};

export const useRecentActivities = ({ config }: UseRecentActivitiesOptions) => {
  return useQuery<RecentActivity[]>({
    queryKey: ['RecentActivities'],
    queryFn: getRecentActivities,
    ...config,
  });
};
